import { useEffect, useState } from 'react';
import { useAppDispatch } from 'src/hooks/redux';
import { ISuggestionsRequest } from 'src/redux/shopping_cart/model';
import { getSuggestedCalc } from 'src/redux/shopping_cart/thunks';
import * as yup from 'yup';
const initialDataForm: ISuggestionsRequest = {
    country: 'MX',
    email: '',
    type_user: 2,
};
export const useSuggestedForm = () => {
    const dispatch = useAppDispatch();
    const [errors, setErrors] = useState({})
    const [blur, setBlur] = useState(false)
    const [dataForm, setDataForm] = useState<ISuggestionsRequest>(initialDataForm);
    const [isValid, setIsValid] = useState(false)
    const handleChange = (name: string, value: any) => {
        setBlur(true)
        setDataForm({
            ...dataForm,
            [name]: value,
        });
    };

    const validateFormData = async () => {
        if (blur) {
            const schema = yup.object().shape({
                email: yup.string().required('El campo es requerido')
                    .test(
                        'is-valid-search',
                        'El campo debe tener un valor válido',
                        value => RegExp(/^\d+$/).test(value || '') || RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(value || '')
                    )
            });
            try {
                await schema.validate(dataForm, { abortEarly: false });
                setIsValid(true);
                setErrors({});
            } catch (err) {
                setIsValid(false);
                setErrors(err.inner.reduce((acc: any, error: any) => {
                    acc[error.path] = error.message;
                    return acc;
                }, {}));
            }
        }
    }


    const handleSubmit = async () => {
        dispatch(getSuggestedCalc(dataForm));
    };

    useEffect(() => {
        validateFormData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataForm])

    return {
        handleChange,
        handleSubmit,
        isValid,
        errors
    };
};
